<template>
    <v-toolbar dense color="white">
        <v-toolbar-side-icon class="hidden-lg-and-up" @click.stop="$emit('toggleNavBar')"></v-toolbar-side-icon>
        <!-- <v-toolbar-title>Title</v-toolbar-title> -->
        <v-spacer></v-spacer>
        <v-toolbar-title class="language">English</v-toolbar-title>
        <v-toolbar-items class="hidden-sm-and-down">
            <v-btn icon>
                <v-icon>notifications_none</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>search</v-icon>
            </v-btn>
            <!-- <img src="../../assets/logo1_thumb.png"> -->
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>

<style>
    .theme--light.v-toolbar {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1705);
        border-radius: 2px;
    }
    .v-toolbar__title.language{
        font-size: 14px;
    }
</style>
